export const appVersion = config => {
  const pluginData = {
    'app:web:version': config.version.web
  };
  if (config.version.ssr) {
    pluginData['app:ssr:version'] = config.version.ssr;
  }
  return pluginData;
};